<template>

  <div>
    <nav-breadcrumb :menu="[{label:  '还款申请审核'}]"/>
    <el-steps  class="step-shenpi">
      <el-step :title="'提交减免'" :description = "$moment(repayInfo.t__applicationDate).format('YYYY-MM-DD HH:mm:ss')">
        <i class="step-start" slot="icon"></i>
      </el-step>
      <el-step v-if="approvalList.length>0" :title="Status2CN(approvalList[0].a__approvalType)+approvalList[0].a__approverName" :description="$moment(approvalList[0].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[0].a__approvingStatus)" >
        <i class="step-mid" slot="icon"></i>
      </el-step>

      <el-step v-if="approvalListcount>1" :title="Status2CN(approvalList[1].a__approvalType)+approvalList[1].a__approverName" :description="$moment(approvalList[1].a__approvingDate).format('YYYY-MM-DD HH:mm:ss')+Status2CN(approvalList[1].a__approvingStatus)" >
        <i class="step-mid" slot="icon"></i>
      </el-step>

      <div class="el-step is-end" v-if="approvalListcount==0&&repayInfo.t__applicationStatus == 'Pending Approval'">
        <i class="step-over" slot="icon"></i>
        <p class="text1">总经理审核</p>
        <p class="text2">待审核</p>
      </div>
      <div class="el-step is-end" v-if="approvalListcount==1&&repayInfo.t__applicationStatus == 'Pending Approval'">
        <i class="step-over" slot="icon"></i>
        <p class="text1">终审</p>
        <p class="text2">待审核</p>
      </div>
    </el-steps>
  <repay-for-approval :financing-detail="repayInfo" :transfer-repayment-detail="repayInfo" :editable="false" :repay-plan-list="repayInfo.detail" @close="repayForApprovalDialogVisible=false"></repay-for-approval>
    <panel title="">
      <panel>备注：{{repayInfo.t__remarks}}</panel>

      <panel><data-table
        :table-data="approvalArry"
        :columns="tableColumns"
        :is-pagination-show="false"
      /></panel>
      <Panel>审核意见：<el-input type="textarea" v-model="repayInfo.a__remarks" ></el-input></Panel>
    </panel>
    <div class="tr xzmt">
      <el-button type="primary" @click="updateApproveRepayment('Approved')">审核通过</el-button>
      <el-button @click="updateApproveRepayment('Rejected')">否决</el-button>
    </div>
  </div>
</template>

<script>
  import RepayForApproval from "../components/RepayForApproval";
  import xhr from '../../utils/xhr'
  import moment from 'moment'
  import Panel from "../../components/Panel";
  import Status2CN from "../../filters/Status2CN";
    export default {
        name: "ApplyingRepaymentEdit",
      components: {Panel, RepayForApproval},
        data(){
          return{
            approvalListcount:0,
            approvalList:[],
            approvalArry:{
              data:[],
              count:0,
            },
            repayInfo:{},
            applicationId:this.$route.query['applicationId']||'',
            tableColumns: [
              {
                label: '节点',
                field: 'node',
                formatter: function (r,c,v) {
                  return Status2CN(v)
                }
              },
              {
                label: '操作人',
                field: 'approverName'
              },
              {
                label: '操作时间',
                field: 'time',
                formatter: function (r,c,v) {
                  return v ? moment(v).format('YYYY-MM-DD HH:mm:ss') : ''
                }
              },
              {
                label: '操作结果',
                field: 'status'
              }, {
                label: '操作备注',
                field: 'remarks'
              },

            ],
          }
        },
      mounted() {
        this.getData()

      },
      methods:{
        Status2CN,
        getData: function () {
          xhr.getViewRepayForApproval(
            {
              't.applicationId': this.applicationId
            },
            res => {
              const repayInfo = res.data.data || {}
              this.repayInfo = repayInfo
              this.repayInfo.de__txDate= moment(repayInfo.t__repayDate).format('YYYY-MM-DD HH:mm:ss')
              this.approvalArry.data.push(
                {
                  node:'提交减免',
                  approverName:this.repayInfo.createdBy__userName,
                  time:this.repayInfo.t__applicationDate,
                  status:'提交成功',
                  remarks:'',

                }
              )
              res.data.data.approvals.forEach(item=>{
                console.log(item)
                if(item.a__approvalId){
                  this.approvalList.push(item)
                  this.approvalArry.data.push(
                    {
                      node:item.a__approvalType,
                      approverName:item.a__approverName,
                      time:item.a__approvingDate,
                      status:Status2CN(item.a__approvingStatus),
                      remarks:item.a__remarks,

                    }
                  )
                }
              })
              this.approvalList.count = this.approvalList.length
              console.log(this.approvalList)
              console.log('******************')
            }
          )
        },
        updateApproveRepayment:function (status){
          const form ={}
          form.t__applicationId = this.applicationId
          form.a__applicationId = this.applicationId
          form.a__approvingStatus=status
          form.a__remarks = this.repayInfo.a__remarks
          form.t__checked = true
          xhr.updateApproveRepayment(
            form,
            res=> {
              try{
                if(res.data.status == 'success') {
                  this.$router.push({
                    path: 'List',
                  })
                }else{

                  this.$message.error(res.data.msgs[0].text)
                }

              }catch (e) {

                this.$message.error(error.msgs[0].text)

              }
            }
          )
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/fang/ApplyingRepaymentEdit.vue